export default __webpack_public_path__ + "static/media/logo_transparent.03a91f1a.png";